import PropTypes from 'prop-types';

import ShopperHeading from 'shopper/components/Heading';

const Heading = ({ children }) => (
  <ShopperHeading as="h2" className="mb-4 text-center" size="size6">
    {children}
  </ShopperHeading>
);

Heading.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Heading;
